<div class="gt-routes-list-containerss height-limit">
  <div class="form-style column" [style.backgroundColor]="'inherit'">
    <div class="grid-view-container">
      <div class="tc-grid-wrapper">
        <div class="custom-toolbar">
          <div class="custom-toolbar-left">
            <dx-text-box
              [(value)]="searchTerm"
              mode="search"
              valueChangeEvent="keyup"
              width="100%"
              class="custom-search-panel"
              (onValueChanged)="dataGridSearch.instance.searchByText($event.value)"
              i18n-placeholder="@@infrastructureSearch"
              placeholder="Search infrastructure..."
            >
            </dx-text-box>
          </div>

          <app-gpd-button
            text="ADD COMPONENT"
            (onClick)="addComponent()"
            icon="add"
            i18n-text="@@addComponentCaps"
          ></app-gpd-button>
        </div>

        <div class="inner-grid-panel">
          <dx-data-grid
            #dataGridSearch
            class="gpd-datagrid"
            [dataSource]="gridConnectionComponentList"
            [showRowLines]="false"
            [hoverStateEnabled]="true"
            [rowAlternationEnabled]="false"
            [selectedRowKeys]="selectedRow"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [columnAutoWidth]="false"
            [showBorders]="false"
            [width]="'100%'"
            [height]="availableHeight + 'px'"
            [noDataText]="noDataText"
            (onContentReady)="getGridPageInfo()"
            (onOptionChanged)="onGridOptionChanged($event)"
            (onRowClick)="onComponentRowClick($event)"
            [scrolling]="{ mode: 'standard', useNative: false, showScrollbar: 'never' }"
            [showColumnLines]="true"
          >
            <dxo-editing [allowDeleting]="allowDeletingVisible"></dxo-editing>
            <dxo-selection
              mode="single"
              [allowSelectAll]="false"
              showCheckBoxesMode="none"
            ></dxo-selection>
            <dxo-paging [enabled]="true" [pageSize]="dynamicPageSize"></dxo-paging>
            <dxo-pager [visible]="false"></dxo-pager>
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-header-filter [visible]="true"></dxo-header-filter>

            <dxi-column
              i18n-caption="@@model"
              caption="Model"
              dataField="model"
              [allowHeaderFiltering]="true"
            ></dxi-column>
            <dxi-column
              i18n-caption="@@manufacturer"
              caption="Manufacturer"
              dataField="manufacturerName"
              [allowHeaderFiltering]="true"
            ></dxi-column>
            <dxi-column
              i18n-caption="@@type"
              caption="Type"
              dataField="typeId"
              [lookup]="{dataSource: componentTypes, displayExpr: 'name', valueExpr: 'id'}"
            ></dxi-column>
            <dxi-column
              dataField="siteQuantity"
              caption="Quantity"
              i18n-caption="@@quantityAnzhal"
              [allowHeaderFiltering]="false"
            ></dxi-column>
            <dxi-column
              dataField
              allowEditing="false"
              cellTemplate="buttonCellTemplate"
              [width]="75"
              [formItem]="{ visible: false }"
            >
              <div *dxTemplate="let item of 'buttonCellTemplate'">
                <app-gpd-button
                  icon="edit"
                  type="text"
                  class="edit-button"
                  (onClick)="editComponent(item.data)"
                >
                </app-gpd-button>
              </div>
            </dxi-column>
          </dx-data-grid>

          <!-- Details Panel -->
          <app-component-details-panel
            [visible]="detailsPanelVisible"
            [componentDetails]="componentDetails"
            [doclinks]="doclinks"
            [componentId]="componentId"
            [documentList]="documentList"
            [sites]="sitesForPanel"
            [projects]="projectsForPanel"
            [disableDownloadAll]="disableDownloadAll"
            [showDownloadAllButton]="!disableDownloadAll"
            (onClose)="closeDetailsPanel()"
            (onEdit)="onEditFromPanel()"
            (onDownloadAll)="downloadAllDocs()"
          ></app-component-details-panel>
        </div>

        <div class="bottom-toolbar">
          <app-gpd-button
            type="tertiary"
            icon="download"
            i18n-text="@@export"
            text="Export"
            (onClick)="exportComponentData()"
          ></app-gpd-button>

          <app-gpd-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [itemsPerPage]="totalItems === 0 ? 0 : (showingTo - showingFrom + 1)"
            [totalItems]="totalItems"
            (onPageChange)="onPageChange($event)"
          ></app-gpd-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showErrMsg" class="gpd-overlay">
  <p>{{ errMsg }}</p>
  <div style="margin-top: 30px"></div>
  <div class="gpd-overlay-footer-center" style="gap: 20px">
    <app-gpd-button
      i18n-text="@@closeText"
      text="Close"
      (onClick)="closeErrMsg()"
      type="secondary"
    ></app-gpd-button>
    <app-gpd-button
      i18n-text="@@goToLibrary"
      text="Go To Library"
      (onClick)="goToComponentLibrary()"
      icon="arrow-right"
    ></app-gpd-button>
  </div>
</div>

<app-generic-popup
  [(visible)]="editComponentVisible"
  (onHiding)="closePopup()"
  i18n-title="@@editComponent" title="Edit Component"
  [width]="'478px'"
  [leftButtons]="editPopupLeftButtons"
  [buttons]="editPopupButtons"
  [allowOutsideClick]="true"
>
  <p class="gpd-popup-description" i18n="@@editComponentDescriptionSite">
    Adjust how many units of this component are installed at the current site.
  </p>
  <dx-form [formData]="selectedComponent" colCount="2" labelLocation="top" [showColonAfterLabel]="false">
    <dxi-item itemType="group" colCount="2" colSpan="2">
      <dxi-item
        editorType="dxTextBox"
        i18n-caption caption="Manufacturer"
        dataField="manufacturerName"
        colSpan="2"
        [editorOptions]="{readOnly:true}"
      >
        <dxo-label i18n-text="@@manufacturer" text="Manufacturer"></dxo-label>
      </dxi-item>
      <dxi-item
        editorType="dxNumberBox"
        i18n-caption caption="Site Quantity"
        dataField="siteQuantity"
        colSpan="2"
        [editorOptions]="{maxLength: 50}"
      >
        <dxo-label i18n-text="@@siteQuantity" text="Site Quantity"></dxo-label>
      </dxi-item>
    </dxi-item>
  </dx-form>
</app-generic-popup>

<!--#region Grid of available components to add -->
<app-generic-popup
  [(visible)]="addComponentVisible"
  (onHiding)="closeAddComponent()"
  i18n-title="@@addComponentToProject"
  title="Add Component"
  [width]="'700px'"
  [buttons]="addPopupButtons"
  [allowOutsideClick]="true"
>
  <p class="gpd-popup-description" i18n="@@addComponentToSiteDescription">
    Select a component from the library to add it to this site. Only completed components can be added. Enter the quantity once you've made your selection.
  </p>
  <div style="height: 40px; margin-bottom: 8px;">
    <dx-text-box
      [(value)]="addComponentSearchTerm"
      mode="search"
      valueChangeEvent="keyup"
      width="350px"
      class="custom-search-panel"
      (onValueChanged)="dataGridSearch2.instance.searchByText($event.value)"
      i18n-placeholder="@@search..."
      placeholder="Search ..."
    >
    </dx-text-box>
  </div>
  <dx-data-grid
    #dataGridSearch2
    class="gpd-datagrid"
    [dataSource]="componentList"
    [paging]="{ enabled: true, pageSize: 10 }"
    [pager]="{ visible: false }"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [showRowLines]="false"
    [showColumnLines]="true"
    [scrolling]="{ mode: 'standard', useNative: true }"
    [width]="'100%'"
    [rowAlternationEnabled]="false"
    [hoverStateEnabled]="true"
    (onRowClick)="onRowClick($event)"
    [selectedRowKeys]="selectedRow"
    keyExpr="componentId"
    height="auto"
    (onContentReady)="getAddComponentGridPageInfo()"
    (onOptionChanged)="onAddComponentGridOptionChanged($event)"
    (onRowPrepared)="onRowPrepared($event)"
  >
    <dxo-selection mode="single"></dxo-selection>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxi-column
      i18n-caption="@@model"
      caption="Model"
      dataField="model"
      [allowHeaderFiltering]="true"
    ></dxi-column>
    <dxi-column
      i18n-caption="@@manufacturer"
      caption="Manufacturer"
      dataField="manufacturerName"
      [allowHeaderFiltering]="true"
    ></dxi-column>
    <dxi-column
      i18n-caption="@@type"
      caption="Type"
      dataField="typeId"
      [lookup]="{dataSource: componentTypes, displayExpr: 'name', valueExpr: 'id'}"
    ></dxi-column>
    <dxi-column
      caption=""
      dataField="isCompleted"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      cellTemplate="warningIconTemplate"
      [width]="40"
    >
      <div *dxTemplate="let item of 'warningIconTemplate'">
        <div *ngIf="!item.data.isCompleted" class="warning-icon-wrapper">
          <i class="dx-icon dx-icon-warning warning-icon"></i>
          <span class="warning-tooltip" i18n="@@incompleteComponentTooltip">This component can only be added to projects if it is complete. Please finish it in the library.</span>
        </div>
      </div>
    </dxi-column>
  </dx-data-grid>
  <div class="add-popup-bottom">
    <app-gpd-pagination
      [currentPage]="addComponentCurrentPage"
      [totalPages]="addComponentTotalPages"
      [itemsPerPage]="addComponentTotalItems === 0 ? 0 : (addComponentShowingTo - addComponentShowingFrom + 1)"
      [totalItems]="addComponentTotalItems"
      (onPageChange)="onAddComponentPageChange($event)"
    ></app-gpd-pagination>
    <div *ngIf="showQuantityInput" class="quantity-row">
      <label i18n="@@quantityAnzhal" style="margin: 0; white-space: nowrap;">Quantity:</label>
      <dx-number-box
        [(value)]="siteQuantity"
        format="#,##0.##"
        style="width: 100%"
      ></dx-number-box>
    </div>
  </div>
</app-generic-popup>
